import {
  GET_SRCH_SELECT,
  GET_ALL_STUDENTS,
  GET_STUDENT,
  GET_CLASS_PERIODS,
  GET_STUDENTS_ABSENTEES,
  GET_ALL_HOME_WORK,
  GET_STUDENTS_HOME_WORK_STATUS,
  GET_ALL_ASSIGNMENT,
  GET_STUDENTS_ASSIGNMENT_STATUS,
  GET_ALL_NOTICE_BOARDS,
  GET_ALL_CIRCULAR,
  GET_COURSE_STUDENTS_LEAVE,
  GET_COURSE_STUDENTS,
  GET_STUDENT_LEAVES,
  GET_DAY_TIME_SLOTS_FOR_COURSE,
  GET_EMPLOYEE_TIME_SLOTS,
  GET_ALL_MEETING,
  GET_MEETING,
  GET_STUDENT_FULL_INFO,
  CLEAR_STUDENT_FULL_INFO,
  GET_COURSE_TIME_TABLE,
} from 'actions/admin/students';

const initialState = {
  srchSelectList: [],
  studentsData: {
    content: [],
  },
  student: {},
  courseStudentData: {
    content: [],
  },
  // Attendance
  classPeriodList: [],
  studentsAbsenteesList: [],
  // Home work
  homeWorkList: [],
  studentsHomeWorkStatusList: [],
  // Assignment
  assignmentsData: {
    content: [],
  },
  studentsAssignmentStatusList: [],
  // Notice board
  noticeBoardList: [],
  // Circular
  circularList: [],
  // Leave
  studentsLeaveData: {
    content: [],
  },
  studentLeaves: [],
  // Reports
  courseDayTimeSlots: [],
  employeeTimeSlots: [],
  // Meeting
  meetingsData: {
    content: [],
  },
  meeting: {},
  // Student view
  studentId: 0,
  profile: {},
  activities: [],
  appreciations: {},
  homework: {},
  assignments: {},
  feeStructure: {},
  payments: {},
  lastFetch: {},
  studentFeesStructure: [],
  courseTimeTableList: [],
};

export default function students(state = initialState, action = {}) {
  switch (action.type) {
    case GET_SRCH_SELECT:
      return { ...state, srchSelectList: action.srchSelectData };
    case GET_ALL_STUDENTS: {
      return { ...state, studentsData: action.studentsData };
    }
    case GET_STUDENT:
      return { ...state, student: action.student };
    case GET_CLASS_PERIODS: {
      return { ...state, classPeriodList: action.classPeriods };
    }
    case GET_STUDENTS_ABSENTEES:
      return { ...state, studentsAbsenteesList: action.studentsAbsentees };
    case GET_ALL_HOME_WORK:
      return { ...state, homeWorkList: action.homeWorks };
    case GET_STUDENTS_HOME_WORK_STATUS:
      return { ...state, studentsHomeWorkStatusList: action.studentsStatus };
    case GET_ALL_ASSIGNMENT:
      return { ...state, assignmentsData: action.assignmentsData };
    case GET_STUDENTS_ASSIGNMENT_STATUS:
      return { ...state, studentsAssignmentStatusList: action.studentsStatus };
    case GET_ALL_NOTICE_BOARDS:
      return { ...state, noticeBoardList: action.noticeBoards };
    case GET_ALL_CIRCULAR:
      return { ...state, circularList: action.circulars };
    case GET_COURSE_STUDENTS_LEAVE:
      return { ...state, studentsLeaveData: action.sLeaves };
    case GET_COURSE_STUDENTS: {
      return { ...state, courseStudentData: action.courseStudentData };
    }
    case GET_STUDENT_LEAVES: {
      return { ...state, studentLeaves: action.leaves };
    }
    case GET_DAY_TIME_SLOTS_FOR_COURSE: {
      return { ...state, courseDayTimeSlots: action.dayTimeSlots };
    }
    case GET_EMPLOYEE_TIME_SLOTS: {
      return { ...state, employeeTimeSlots: action.empTimeSlots };
    }
    case GET_ALL_MEETING: {
      return { ...state, meetingsData: action.meetingsData };
    }
    case GET_MEETING: {
      return { ...state, meeting: action.meeting };
    }
    case CLEAR_STUDENT_FULL_INFO: {
      return {
        ...state,
        studentId: 0,
        profile: {},
        activities: [],
        appreciations: {},
        homework: [],
        assignments: [],
        studentFeesStructure: [],
      };
    }
    case GET_STUDENT_FULL_INFO: {
      const updateData = () => {
        if (['feeStructure', 'payments']?.includes(action.dataType)) {
          return {
            [action.dataType]: {
              ...state[action.dataType],
              [action.studentId]: action.resData,
            },
          };
        }
        return { [action.dataType]: action.resData };
      };
      return {
        ...state,
        ...(action?.studentId && state.studentId !== action?.studentId && { studentId: action.studentId }),
        ...updateData(),
        lastFetch: {
          ...state.lastFetch,
          [action.dataType]: new Date(),
        },
      };
    }
    case GET_COURSE_TIME_TABLE: {
      return { ...state, courseTimeTableList: action.courseTimeTableList };
    }
    default:
      return state;
  }
}
